export default __webpack_public_path__ + "static/media/browse-req-grap.7af2b44e.svg";